import React, { useState } from 'react';
import { Layout as Alayout } from 'antd';
import './layout.css';
import Sidenav from './sidenav';
import Navbar from './navbar';
import { layoutContext } from '../context';
import { useLocation } from 'react-router-dom';
const { Content, Header } = Alayout;

function Layout({ children }) {
  const [activeComponent, setActiveComponent] = useState(undefined);
  const { pathname } = useLocation();

  return pathname === '/preview' ? (
    <>
      <layoutContext.Provider
        value={{
          activeComponent: activeComponent,
          onChangeActiveComponent: (value) => setActiveComponent(value),
        }}
      >
        <Alayout>
          <Content>
            <div style={{ padding: '15px 20px 15px 70px' }}>{children}</div>
          </Content>
        </Alayout>
      </layoutContext.Provider>
    </>
  ) : (
    <>
      <layoutContext.Provider
        value={{
          activeComponent: activeComponent,
          onChangeActiveComponent: (value) => setActiveComponent(value),
        }}
      >
        <Alayout style={{ height: '100vh' }}>
          <Header>
            <Navbar />
          </Header>
          <Alayout>
            <div className="position-sidebar">
              <Sidenav />
            </div>
            <Alayout>
              <Content>
                <div
                  id={'children-wrapper'}
                  style={{
                    padding: '15px 20px 15px 70px',
                    overflowY: 'auto',
                    maxHeight: '100%',
                    minHeight: '100%',
                    overflowX: 'hidden',
                  }}
                >
                  {children}
                </div>
              </Content>
            </Alayout>
          </Alayout>
        </Alayout>
      </layoutContext.Provider>
    </>
  );
}
export default Layout;
